import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class EncryptedBoxViewModel extends ControlViewModel {

    /**
     * Ein Image
     */
    public image: ImageViewModel;

    /**
     * Ein Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für die EncryptedBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.image = this.paramOrDefault(params.image, null);
        this.label = this.paramOrDefault(params.label, null);
    }
}

ComponentManager.setViewModel('EncryptedBoxViewModel', EncryptedBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');